(function () {

  angular
    .module('meanApp')
    .directive('mobiletoolbar', mobiletoolbar);

  function mobiletoolbar () {
    return {
      restrict: 'EA',
      templateUrl: '/common/directives/mobileToolbar/mobile.toolbar.template.html',
      replace: true,
      controller: 'navigationCtrl as vm'
    };
  }

})();